/* eslint eqeqeq: "off" */
import React, { useContext, useState } from "react";
import axios from "axios";
import Context from "./Context";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import GerarPades from "../functions/GerarPades";
pdfMake.addVirtualFileSystem(pdfFonts);

const crypto = require('crypto');
const base64url = require('base64url');

function Assinatura() {
  // context.
  const {
    usuario,
    setdocumentos,
    html,
    paciente,
    setselecteddocumento,
  } = useContext(Context);

  /*
  Encaminhando para o pulsar-pep uma lista de PROVEDORES DE SERVIÇOS DE CONFIANÇA (birdid, VIDaaS), conhecidos como CLEARANCES,
  capazes de autentucar e realizaar assinaturas em nome de um PROPONENTE (médico).
  */

  // criando a senha RFC 7636.
  let localsecretDataForSignautresAndCredentials = '';
  let localsecretDataForAuthentications = '';
  const createSecret = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    for (let i = 0; i < 43; i++) {
      let randomIndex = Math.floor(Math.random() * characters.length);
      localsecretDataForSignautresAndCredentials += characters.charAt(randomIndex);
    }
    localsecretDataForAuthentications = base64url.encode(crypto.createHash('sha256').update(localsecretDataForSignautresAndCredentials).digest());
    console.log(localsecretDataForAuthentications);
    localStorage.setItem('secret', localsecretDataForAuthentications);
    localStorage.setItem('secret_signature', localsecretDataForSignautresAndCredentials);
  }

  // ETAPA 1: AUTHENTICATIONS (autenticação e identificação do proponente).
  const [listclearances, setlistclearances] = useState([]);
  const CHANNEL = '04a1777c-92f8-4759-84be-b5a87767c641'; // a receber da IntegralICP.

  const getClearances = () => {
    createSecret();
    const SUBJECT = usuario.cpf_usuario;
    const SECRET = localsecretDataForAuthentications;
    console.log('SECRET EM getClearances(): ' + SECRET);
    // const CALLBACK = 'http://localhost:3000/#/assinatura-callback';
    const CALLBACK = 'https://pulsarpep.com/#';
    axios.get(`https://services.integraicp.com.br/c/${CHANNEL}/icp/v3/authentications?subject_key=${SUBJECT}&secret_data=${SECRET}&callback_uri=${CALLBACK}&autostart=true`).then(response => {
      console.log(response.data.data.clearances);
      setlistclearances(response.data.data.clearances);
    }).catch(error => { console.log(error) });
  }

  const getCredentials = () => {
    let CREDENTIAL = localStorage.getItem('credentialId');
    const SECRET = localStorage.getItem('secret_signature');
    // console.log(`https://services.integraicp.com.br/c/04a1777c-92f8-4759-84be-b5a87767c641/icp/v3/credentials/01K8V2TGCK48FYV382WGBZ5H7S?secret_data=kVksAbNEINTzPOzsyJuJ-obO2-0YWGvmU5YmJpfvKn0`);
    axios.get(`https://services.integraicp.com.br/c/${CHANNEL}/icp/v3/credentials/${CREDENTIAL}?secret_data=${SECRET}`).then((response) => {
      console.log(response);
    });
  }

  const requestSignature = () => {
    let signedContent = localStorage.getItem('cms_content');
    signedContent = null;
    if (signedContent == null) {
      let credentialId = localStorage.getItem('credentialId');
      const SECRET = localStorage.getItem('secret_signature');
      let documento = localStorage.getItem('sha256base64doc');
      let obj = {
        credentialId: credentialId,
        secretType: "code_verifier",
        secretData: SECRET,
        requests: [
          {
            contentId: "doc_001",
            contentDigest: documento,
            contentDescription: "Documento eletrônico Pulsar PEP",
            signaturePolicy: "CMS" // PENDÊNCIA! TENTAR RECEBER PADES. A OUTRA OPÇÃO DISPONÍVEL AQUI É O RAW.
          }
        ]
      }
      axios.post(`https://services.integraicp.com.br/c/${CHANNEL}/icp/v3/signatures`, obj).then(response => {
        console.log(response.data);
        let arraysignatures = response.data.data.signatures;
        localStorage.setItem('signature', JSON.stringify(response.data));
        // eslint-disable-next-line
        arraysignatures.map(content => {
          let signedContent = content.signedContent;
          localStorage.setItem('cms_content', signedContent);
          // PENDÊNCIA: função que junta o pdf original com o CMS, criando o PADES.
          GerarPades();
        });
      }).catch(error => {
        console.log(error);
      })
    } else {
      console.log('JÁ TENHO O CMS');
    }
  }

  function ListaDeClearances() {
    return (
      <div id='lista_clearances'>
        {listclearances.map(clearance => (
          <div className="button"
            style={{
              display: 'flex', flexDirection: 'row', justifyContent: 'center',
              width: 150, minWidth: 150, height: 150, minHeight: 150
            }}
            onClick={() => {
              window.open(clearance.clearanceEndpoint);
              document.getElementById('lista_clearances').style.display = 'none';
              document.getElementById('btn_assinar').style.display = 'flex';
            }}
          >
            <div>{clearance.productName}</div>
          </div>
        ))}
      </div>
    )
  }

  const loadDocumentos = () => {
    setdocumentos([]);
    axios.get(html + "list_documentos_idpct/" + paciente).then((response) => {
      var x = response.data.rows;
      setdocumentos(x.sort((a, b) => moment(a.data) < moment(b.data) ? 1 : -1));
      setselecteddocumento([]);
    })
  }

  function BtnAssinar() {
    return (
      <div id='btn_assinar'
        className="button"
        style={{ display: 'none', flexDirection: 'row', justifyContent: 'center', width: 200, minWidth: 200 }}
        onClick={() => {
          let credentialId = localStorage.getItem('credentialId');
          console.log(credentialId);
          getCredentials();
          requestSignature();
          document.getElementById('componente_assinatura').style.display = 'none'
          setTimeout(() => {
            loadDocumentos();
          }, 3000);
        }}
      >
        <div>{'ASSINAR'}</div>
      </div>
    )
  }

  return (
    <div
      id='componente_assinatura'
      style={{ display: 'none' }}
      className='fundo' onClick={() => document.getElementById('componente_assinatura').style.display = 'none'}>
      <div
        className='janela scroll'
        onClick={(e) => e.stopPropagation()}
      >
        <div id='btn_buscar_clearances' className="button"
          style={{ width: 200, minWidth: 200 }}
          onClick={() => {
            getClearances()
            document.getElementById('btn_buscar_clearances').style.display = 'none';
            document.getElementById('lista_clearances').style.display = 'flex';
          }}>
          BUSCAR PROVEDORES DE ASSINATURA
        </div>
        <ListaDeClearances></ListaDeClearances>
        <BtnAssinar></BtnAssinar>
      </div>
    </div >
  )
}

export default Assinatura;